export const AVATAR_BACKGROUND_COUNT = 26

const RASTER_LETTERS = new Set(['v', 'z'])

export const stringHash = (value: string) => {
  let hash = 5381
  let index = value.length

  while (index) {
    hash = (hash * 33) ^ value.charCodeAt(--index)
  }

  return hash >>> 0
}

export const avatarAssets = (seed: string) => {
  const letter = seed.charAt(0).toLocaleLowerCase()
  const hasLetterAsset = /^[a-z]$/.test(letter)
  const extension = RASTER_LETTERS.has(letter) ? 'png' : 'svg'

  return {
    background: `/avatars/${(stringHash(seed) % AVATAR_BACKGROUND_COUNT) + 1}.jpg`,
    letter: hasLetterAsset ? `/avatars/${letter}.${extension}` : null,
    fallbackLetter: seed.charAt(0).toLocaleUpperCase()
  }
}
